import { HowToPlaySceneBase } from "src/games/shared/scenes/HowToPlaySceneBase";
import { Games } from "src/constants/Games";
import { MainScene } from "./MainScene";
import { GameIntroScene } from "./GameIntro";

export class HowToPlayScene extends HowToPlaySceneBase {
    constructor() {
        super();
        this.gameRef = Games.XRay;
        this.mainScene = MainScene;
        this.gameIntroScene = GameIntroScene;
        this.gameObjectiveTextKey = "XRay.Phaser.HowToPlay.objectiveText";
        this.howToPlayOnComputerTextKey = "XRay.Phaser.HowToPlay.computerInstructions";
        this.howToPlayOnTabletTextKey = "XRay.Phaser.HowToPlay.tabletInstructions";
    }
}



// WEBPACK FOOTER //
// ./src/games/XraySlider/scenes/IntroductionScene.ts